import { ApaduaLegacyAPI } from './ApaduaLegacyAPI';

export class OrganizationWorkerRolesLegacyAPI extends ApaduaLegacyAPI {
    resource: string = 'api/organization-worker-roles/';

    getWorkerRoles(): Promise<any> {
        return this.get('') as any;
    }
}
